
export default {
  methods: {
    async onImport(file: File) {
      try {
        const data = await this.$repo.user.importUsers(file);
        await this.showUploadResult(data);
      } catch (err) {
        await this.showUploadResult(err.response.data);
      }
    },
    async showUploadResult(data) {
      const randomFactor = Math.random()
        .toString(36)
        .substr(2);
      const idSrc = `000000${randomFactor}`;
      const id = idSrc.substr(idSrc.length - 6);
      await this.$repo.user.saveImportResult(id, data);
      this.$router.push({
        name: 'management:user:import:result',
        params: {
          id
        }
      });
    }
  }
};
